import React from "react";
import { RefreshCw } from "lucide-react";
import { UserTableRow } from "./UserTableRow";

export function UserTable({ users, loading, isRoot, organizations, actions }) {
  return (
    <div className="bg-slate-900/50 border border-slate-800 rounded-xl overflow-hidden">
      <table className="w-full">
        <thead className="bg-slate-800/50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase">Usuario</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase">Organización</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase">Plan</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase">Rol</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-400 uppercase">Superadmin</th>
            <th className="px-4 py-3 text-right text-xs font-medium text-slate-400 uppercase">Acciones</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-800">
          {loading ? (
            <tr>
              <td colSpan={6} className="px-4 py-8 text-center">
                <RefreshCw className="w-6 h-6 text-amber-400 animate-spin mx-auto" />
              </td>
            </tr>
          ) : users.length === 0 ? (
            <tr>
              <td colSpan={6} className="px-4 py-8 text-center text-slate-400">
                No se encontraron usuarios
              </td>
            </tr>
          ) : (
            users.map((user) => (
              <UserTableRow
                key={user.user_id}
                user={user}
                isRoot={isRoot}
                organizations={organizations}
                actions={actions}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
